var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-box"},[_c('Tabs',{staticClass:"tab-box",attrs:{"value":"enterpriseAnnouncement"}},[_c('TabPane',{attrs:{"label":"企业公告","name":"enterpriseAnnouncement"}},[_c('dataplat-enterprise-announcement')],1),_c('TabPane',{attrs:{"label":"年报统计信息","name":"statistics"}},[_c('dataplat-statistics')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }